/* tslint:disable */
/* eslint-disable */
/**
 * SupportService
 * Operation workflow management system
 *
 * The version of the OpenAPI document: v1
 * Contact: info@mrbilit.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @enum {string}
 */

export const SessionStatus = {
    Active: 'Active',
    Pending: 'Pending',
    Expired: 'Expired',
    Cancelled: 'Cancelled',
    UnderReview: 'UnderReview'
} as const;

export type SessionStatus = typeof SessionStatus[keyof typeof SessionStatus];



